export const TOGGLE_VIEW = {
  PREPARE: 'PREPARE',
  LAUNCH: 'LAUNCH',
  MONITOR: 'MONITOR',
}
